import React, { useCallback, useEffect, useState, useRef } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import { Card, Grid } from "@mui/material";
import SearchBar from "components/SearchBar";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Spinner,
  Row,
  Col,
  Table,
  ButtonGroup,
} from "reactstrap";
import { formatNumber } from "redux/action/api";
import { useToasts } from "helper/ToastAdapter";
import { useNavigate } from "react-router-dom";
import { postApi } from "redux/action/api_tbeams";
import { getSector } from "helper";

export default function MonthlyRecurrent() {
  const navigate = useNavigate();
  const { addToast } = useToasts();
  const [form, setForm] = useState({});
  const [searchText, setSearchText] = useState("");
  const [modal, setModal] = useState(false);
  const [approveData, setApproveData] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    value: "overhead",
    title: " Monthly Overhead",
  });

  const [loading, setLoading] = useState(false);
  const [mdaList, setMdaList] = useState([]);
  const [economicList, setEconomicList] = useState([]);
  const mdaTypeaheadRef = useRef();
  const economicTypeaheadRef = useRef();
  //   let query_type = form.transaction_type !== "" ? "budget_type" : "selects";

  const handleChange = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  const getApproveData = useCallback(() => {
    setLoading(true);
    postApi(`monthly-recurrent?query_type=select`, {
      rec_type: selectedOption.value,
    })
      .then((res) => {
        if (res.success) {
          setLoading(false);
          setApproveData(res.results);
        }
      })
      .catch((err) => {
        alert(err);
        addToast(err, {
          appearance: "info",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectedOption.value]);

  useEffect(() => {
    getApproveData();
  }, [getApproveData]);

  // Load MDA and Economic lists for typeahead
  useEffect(() => {
    getSector({ type: "ADMINISTRATIVE SEGMENT" }, "select", (d) => {
      setMdaList(d || []);
    });
    getSector({ type: "ECONOMIC SEGMENT" }, "select", (d) => {
      setEconomicList(d || []);
    });
  }, []);

  //   const handleDoubleClick = (index) => {
  //     setEditingIndex(index);
  //   };

  //   const handleInputBlur = () => {
  //     setEditingIndex(-1);
  //   };
  //   const handleChanges = (value, index) => {
  //     const arr = [...results];
  //     arr[index].approve_amount = value;
  //     setResults(arr);
  //   };

  let data = [];

  approveData?.forEach((item) => {
    if (
      item.admin_name &&
      item.admin_name?.toLowerCase().indexOf(searchText?.toLowerCase()) === -1
    )
      return;
    else data.push(item);
  });

  const dataByMDA = {};
  data?.forEach((item) => {
    if (Object.keys(dataByMDA)?.includes(item.admin_code)) {
      dataByMDA[item.admin_code] = [...dataByMDA[item.admin_code], item];
    } else {
      dataByMDA[item.admin_code] = [item];
    }
  });

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const options = [
    {
      value: "overhead",
      title: " Monthly Overhead",
    },
   
    {
      value: "salary",
      title: " Monthly Salary",
    },
  ];

  const handleButtonClick = (value, title) => {
    setSelectedOption({ value, title });
  };

  return (
    <DashboardLayout>
      <MDBox pt={1} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography
                  variant="h5"
                  color="white"
                  className="text-center"
                >
                  Monthly Overhead Table
                </MDTypography>
              </MDBox>
              <div className="row" style={{ marginTop: 10, padding: 15 }}>
                <div className="col-md-4">
                  <Button
                    size="sm"
                    color="primary"
                    className=" mt-2 offset-1"
                    onClick={() =>
                      navigate(
                        `/recurrent-setup-form?type=${selectedOption.value}`,
                      )
                    }
                    style={{ width: "100%", marginLeft: 0, marginButtom: 20 }}
                  >
                    Create New {selectedOption.title}
                  </Button>
                </div>
                <div className="col-md-4 mt-2">
                  <SearchBar
                    placeholder="Search By MDA Name"
                    filterText={searchText}
                    onFilterTextChange={handleSearchChange}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <ButtonGroup style={{ width: "100%" }}>
                    {options.map((item) => (
                      <Button
                        size="sm"
                        key={item.title}
                        outline={
                          selectedOption.title !== item.title ? true : false
                        }
                        color={
                          selectedOption.title === item.title
                            ? "success"
                            : "secondary"
                        }
                        onClick={() =>
                          handleButtonClick(item.value, item.title)
                        }
                      >
                        {item.title}
                      </Button>
                    ))}
                  </ButtonGroup>
                </div>
              </div>
              {/* {JSON.stringify(form)} */}
              <MDBox>
                <MDBox pt={0}>
                  <div className=" row p-3">
                    <Table
                      bordered
                      striped
                      className="mt-3"
                      size="sm"
                      style={{ fontSize: 12 }}
                      responsive
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "55%" }}>Description</th>
                          <th style={{ width: "20%" }}>Economic Code</th>
                          <th style={{ width: "15%" }}>Amount</th>
                          <th style={{ width: "10%" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(dataByMDA)
                          .sort((a, b) => {
                            // Sort alphabetically by MDA name
                            const nameA = dataByMDA[a][0]?.admin_name || "";
                            const nameB = dataByMDA[b][0]?.admin_name || "";
                            return nameA.localeCompare(nameB);
                          })
                          .map((group, grpIdx) => {
                            const total = dataByMDA[group].reduce(
                              (a, b) => a + parseFloat(b.amount),
                              0,
                            );
                            return (
                              <React.Fragment key={grpIdx}>
                                <tr>
                                  <td
                                    style={{
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {group}-{dataByMDA[group][0].admin_name}
                                  </td>
                                  <td></td>
                                  <td
                                    style={{
                                      fontWeight: "bold",
                                      textAlign: "right",
                                    }}
                                  >
                                    N{formatNumber(total)}
                                  </td>
                                  <td></td>
                                </tr>
                                {dataByMDA[group].map((item, index) => (
                                  <tr key={`${grpIdx}-${index}`}>
                                    <td>{item.economic_name}</td>
                                    <td>{item.economic_code}</td>
                                    <td
                                      style={{
                                        textAlign: "right",
                                      }}
                                    >
                                      {formatNumber(item.amount)}
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <Button
                                        size="sm"
                                        color="success"
                                        style={{ marginRight: 5 }}
                                        onClick={() => {
                                          setForm(item);
                                          setModal(true);
                                        }}
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        size="sm"
                                        color="danger"
                                        onClick={() => {
                                          if (
                                            window.confirm(
                                              `Are you sure you want to delete this entry?\n\nMDA: ${item.admin_name}\nEconomic: ${item.economic_name}\nAmount: ${formatNumber(item.amount)}`,
                                            )
                                          ) {
                                            setLoading(true);
                                            postApi(
                                              `monthly-recurrent?query_type=delete`,
                                              {
                                                id: item.id,
                                              },
                                            )
                                              .then((res) => {
                                                if (res.success) {
                                                  addToast(
                                                    "Deleted successfully",
                                                    {
                                                      appearance: "success",
                                                      autoDismiss: true,
                                                    },
                                                  );
                                                  getApproveData();
                                                } else {
                                                  addToast(
                                                    res.error ||
                                                      "Delete failed",
                                                    {
                                                      appearance: "error",
                                                      autoDismiss: true,
                                                    },
                                                  );
                                                }
                                              })
                                              .catch((err) => {
                                                addToast(
                                                  err.message ||
                                                    "An error occurred",
                                                  {
                                                    appearance: "error",
                                                    autoDismiss: true,
                                                  },
                                                );
                                              })
                                              .finally(() => {
                                                setLoading(false);
                                              });
                                          }
                                        }}
                                      >
                                        Del
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Edit Modal */}
      <Modal isOpen={modal} toggle={() => setModal(!modal)} size="lg">
        <ModalHeader toggle={() => setModal(!modal)}>
          Edit Monthly {selectedOption.title}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>MDA Name *</Label>
              <Typeahead
                id="mda-typeahead"
                ref={mdaTypeaheadRef}
                labelKey={(option) => `${option.head} - ${option.description}`}
                options={mdaList.filter((item) => item.level >= 3)}
                placeholder="Select MDA"
                defaultSelected={
                  form.admin_code
                    ? mdaList.filter((item) => item.head === form.admin_code)
                    : []
                }
                onChange={(selected) => {
                  if (selected.length) {
                    setForm((p) => ({
                      ...p,
                      admin_name: selected[0].description,
                      admin_code: selected[0].head,
                    }));
                  }
                }}
                onInputChange={(text) => {
                  // Allow manual input
                  setForm((p) => ({ ...p, admin_name: text }));
                }}
              />
            </Col>
            <Col md={6}>
              <Label>MDA Code *</Label>
              <Input
                type="text"
                name="admin_code"
                value={form.admin_code || ""}
                onChange={handleChange}
                placeholder="MDA code (auto-filled)"
              />
            </Col>
            <Col md={6} className="mt-3">
              <Label>Economic Description *</Label>
              <Typeahead
                id="economic-typeahead"
                ref={economicTypeaheadRef}
                labelKey={(option) => `${option.head} - ${option.description}`}
                options={economicList.filter((item) => item.level >= 3)}
                placeholder="Select Economic Description"
                defaultSelected={
                  form.economic_code
                    ? economicList.filter(
                        (item) => item.head === form.economic_code,
                      )
                    : []
                }
                onChange={(selected) => {
                  if (selected.length) {
                    setForm((p) => ({
                      ...p,
                      economic_name: selected[0].description,
                      economic_code: selected[0].head,
                    }));
                  }
                }}
                onInputChange={(text) => {
                  // Allow manual input
                  setForm((p) => ({ ...p, economic_name: text }));
                }}
              />
            </Col>
            <Col md={6} className="mt-3">
              <Label>Economic Code *</Label>
              <Input
                type="text"
                name="economic_code"
                value={form.economic_code || ""}
                onChange={handleChange}
                placeholder="Economic code (auto-filled)"
              />
            </Col>
            <Col md={12} className="mt-3">
              <Label>Amount *</Label>
              <Input
                type="number"
                name="amount"
                value={form.amount || ""}
                onChange={handleChange}
                placeholder="Enter amount"
              />
            </Col>
          </Row>
          <div className="mt-4 d-flex justify-content-end">
            <Button
              color="secondary"
              onClick={() => {
                setModal(false);
                // Clear typeahead selections
                if (mdaTypeaheadRef.current) {
                  mdaTypeaheadRef.current.clear();
                }
                if (economicTypeaheadRef.current) {
                  economicTypeaheadRef.current.clear();
                }
              }}
              className="me-2"
            >
              Cancel
            </Button>
            <Button
              color="success"
              onClick={() => {
                // Validate all required fields
                if (!form.admin_name || !form.admin_name.trim()) {
                  addToast("Please enter MDA name", {
                    appearance: "error",
                    autoDismiss: true,
                  });
                  return;
                }
                if (!form.admin_code || !form.admin_code.trim()) {
                  addToast("Please enter MDA code", {
                    appearance: "error",
                    autoDismiss: true,
                  });
                  return;
                }
                if (!form.economic_name || !form.economic_name.trim()) {
                  addToast("Please enter economic description", {
                    appearance: "error",
                    autoDismiss: true,
                  });
                  return;
                }
                if (!form.economic_code || !form.economic_code.trim()) {
                  addToast("Please enter economic code", {
                    appearance: "error",
                    autoDismiss: true,
                  });
                  return;
                }
                if (!form.amount || parseFloat(form.amount) <= 0) {
                  addToast("Please enter a valid amount", {
                    appearance: "error",
                    autoDismiss: true,
                  });
                  return;
                }

                setLoading(true);
                postApi(`monthly-recurrent?query_type=update`, {
                  id: form.id,
                  admin_name: form.admin_name.trim(),
                  admin_code: form.admin_code.trim(),
                  economic_name: form.economic_name.trim(),
                  economic_code: form.economic_code.trim(),
                  amount: form.amount,
                  rec_type: form.rec_type,
                })
                  .then((res) => {
                    if (res.success) {
                      addToast("Updated successfully", {
                        appearance: "success",
                        autoDismiss: true,
                      });
                      setModal(false);
                      // Clear typeahead selections
                      if (mdaTypeaheadRef.current) {
                        mdaTypeaheadRef.current.clear();
                      }
                      if (economicTypeaheadRef.current) {
                        economicTypeaheadRef.current.clear();
                      }
                      getApproveData();
                    } else {
                      addToast(res.error || "Update failed", {
                        appearance: "error",
                        autoDismiss: true,
                      });
                    }
                  })
                  .catch((err) => {
                    addToast(err.message || "An error occurred", {
                      appearance: "error",
                      autoDismiss: true,
                    });
                  })
                  .finally(() => {
                    setLoading(false);
                  });
              }}
              disabled={loading}
            >
              {loading ? <Spinner size="sm" /> : "Update"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </DashboardLayout>
  );
}
